"use client";

import { useNavigation } from "@/hooks/useNavigation";
import {
  ProgressBar,
  ProgressRoot,
} from "@cloudspire/shared/components/ui/progress";

export function ProgressBarNavigation() {
  const { state } = useNavigation();

  return (
    <ProgressRoot
      colorPalette="primary"
      left="0"
      opacity={state === "loading" ? 1 : 0}
      position="fixed"
      right="0"
      shape="square"
      size="xs"
      top="0"
      transition="opacity .25s ease"
      value={state === "loading" ? null : 0}
      variant="subtle"
      w="full"
      zIndex={1}
    >
      <ProgressBar />
    </ProgressRoot>
  );
}
